<!--suppress ALL -->
<template>
  <div class="dropdown-searching field is-grouped">
    <div class="control is-expanded">
      <slot></slot>
    </div>
    <div class="control" :class="$scopedSlots.right || $slots.right ? 'field is-grouped' : ''">
      <slot v-if="$scopedSlots.right || $slots.right" name="right"></slot>
      <g-dropdown v-if="!skipSearching" position="bottom-left"
                  :class="$scopedSlots.right || $slots.right ? 'control' : ''"
                  :dropdownMenuClass="dropdownMenuClass" ref="dropdownSearching">
        <g-button type="primary" class="has-icon" slot="trigger">
          <span>{{$t('label.searching')}}</span>
          <span class="icon"><i class="fas fa-chevron-down"></i></span>
        </g-button>

        <template v-if="$scopedSlots.custom || $slots.custom">
          <slot name="custom"
                :toggleDropdown="toggleDropdown">
          </slot>
        </template>
        <g-field v-else v-for="(value, key, index) in paramFilter"
                 :label="key | capitalize" :key="`label-search-${key}`">
          <g-input @input="(val) => onInput(val, key)"></g-input>
        </g-field>

        <g-field class="has-text-centered search-btn">
          <template v-if="$scopedSlots.customSlotSearching || $slots.customSlotSearching">
            <slot name="customSlotSearching" :toggleDropdown="toggleDropdown"></slot>
          </template>
          <g-button v-else-if="customSearching"
                    @click="toggleDropdown" type="primary">
            {{$t('label.search')}}
          </g-button>
          <router-link v-else @click.native="toggleDropdown"
                       :to="urlFilter" class="button is-primary">
            {{$t('label.search')}}
          </router-link>
          <slot name="customSlotSearchingAfter"></slot>
        </g-field>
      </g-dropdown>
      <slot v-if="$scopedSlots.rightEnd || $slots.rightEnd" name="rightEnd"></slot>
    </div>
  </div>
</template>

<script lang="ts">
  import {Component, Prop, Vue} from 'annotation';
  import {cloneDeep} from 'lodash';
  import GDropdown from "./common/dropdown/GDropdown.vue";

  @Component({
    components: {GDropdown}
  })
  export default class DropdownSearching extends Vue {
    @Prop({default: {}})
    public paramFilter: any;

    @Prop({default: '/index'})
    public urlFilter: string;

    @Prop({default: false, type: Boolean})
    public customSearching: boolean;

    @Prop({default: false, type: Boolean})
    public skipSearching: boolean;

    public $refs: { dropdownSearching: GDropdown};

    public get dropdownMenuClass() {
      const {$scopedSlots, $slots} = this;
      return $scopedSlots.custom || $slots.custom ? 'has-custom-slot' : '';
    }

    public onInput(value, key) {
      let paramFilter = cloneDeep(this.paramFilter);
      paramFilter[key] = value;
      this.$emit('update:paramFilter', paramFilter);
    }

    public toggleDropdown() {
      if (this.$refs.dropdownSearching) {
        this.$refs.dropdownSearching.toggle();
      }

      this.$emit('search');
    }
  }
</script>

<style lang="scss">
  @import "../../style/variables_function";

  .dropdown-searching {
    align-items: center;

    .dropdown-content {
      min-width: 300px;
      padding: 1rem 1rem;
    }

    .search-btn {
      margin: 0 -1rem -1rem;
      padding: 1rem;
      background: $white-ter;

      .button {
        width: 100%;
      }
    }

    // move 30px if has custom slot
    .has-custom-slot {
      top: 30px;
    }
  }
</style>
